//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "SiftSelect",
  components: {},
  props: ["sift", "col", "label-width"],
  data: function data() {
    return {
      value: ""
    };
  },
  computed: {},
  created: function created() {
    this.value = this.sift.defaultValue ? this.sift.defaultValue : "";
  },
  mounted: function mounted() {},
  destroyed: function destroyed() {},
  methods: {
    setValue: function setValue(value) {
      this.value = value;
    },
    getValue: function getValue() {
      return this.value;
    },
    resetValue: function resetValue() {
      this.value = this.sift.defaultValue ? this.sift.defaultValue : "";
    },
    changeValue: function changeValue() {
      this.$emit("change");
    }
  },
  watch: {},
  filters: {}
};